import 'core-js/stable';
import 'core-js/modules/web.atob';
import 'event-target-polyfill';
import 'regenerator-runtime/runtime';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { store, theme } from '@app/helpers';
import i18n from './app/helpers/i18n';
import MomentUtils from '@date-io/moment';
import './css/style.css';
import './sass/style.scss';
import App from './app/app.component';

if (/MSIE 9/i.test(navigator.userAgent)) {
    document.documentElement.className += ' ie9';
}

if (/MSIE 10/i.test(navigator.userAgent)) {
    document.documentElement.classList.add('ie10');
}

render(
    <I18nextProvider i18n={i18n}>
        <Provider store={store}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
                <MuiThemeProvider theme={theme}>
                    <App />
                </MuiThemeProvider>
            </MuiPickersUtilsProvider>
        </Provider>
    </I18nextProvider>,
    document.getElementById('root')
);
